import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  EntityService,
  CollectionManagerService
} from '@zerops/zef/entities';
import { AppState, ApiEntityKeys } from '@zerops/zerops/app';
import { ZefWebsocketService } from '@zerops/zef/websocket';
import { HttpRouting, HttpRoutingPost, HttpRoutingPut } from '@zerops/models/http-routing';
import { Sort } from '@zerops/zef/sort';

@Injectable({ providedIn: 'root' })
export class HttpRoutingEntity extends EntityService<HttpRouting, HttpRoutingPost, HttpRoutingPut> {

  defaultSort: Sort = {
    key: 'created',
    direction: 'desc'
  };

  list$(
    tag?: string | { name: string; id: string; },
    orderSelector: Array<string | ((i: HttpRouting) => any)> = [ this.defaultSort.key ],
    orderDir: Array<boolean | 'asc' | 'desc'> = [ this.defaultSort.direction ]
  ) {
    return super.list$(tag, orderSelector, orderDir);
  }

  constructor(
    public store: Store<AppState>,
    public collectionManager: CollectionManagerService,
    public websocketService: ZefWebsocketService
  ) {
    super(ApiEntityKeys.HttpRouting, store, collectionManager, websocketService);
  }
}
